import { ActionAction, ActionState } from 'store/data/action';
import { domainUtility } from 'utility';

const initialState: ActionState = {
  allIds: [],
  byId: {},
};

const actionReducer = (
  state: ActionState = initialState,
  action: ActionAction,
): ActionState => {
  switch (action.type) {
    case 'data/action/ADD':
      return domainUtility.add(state, action.payload);
    case 'data/action/SET':
      return domainUtility.set(state, action.payload);
    case 'data/action/UPDATE':
      return domainUtility.update(state, action.payload);
    case 'data/action/REMOVE':
      return domainUtility.remove(state, action.payload);
    case 'data/action/SET_DOMAIN': {
      const { allIds, byId } = action.payload;
      return { allIds, byId };
    }
    default:
      return state;
  }
};

export default actionReducer;
